import axios from "axios";
import { baseURL, baseUrlGateway } from "./config";

const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname.startsWith("192.168.");
const GATEWAY_URL = isLocal ? `http://${window.location.hostname}:5000/v1/post` : `${baseUrlGateway}post`;

export const getPosts = (payload) => {
    return axios.get(`${GATEWAY_URL}/get-list`, { params: payload }).then(res => res.data);
};

export const getPostById = (id) => {
    return axios.get(`${GATEWAY_URL}/get-by-id/${id}`).then(res => res.data);
};
